import styled, {css} from 'styled-components';
import {ErrorMessage} from '../../../styled/common';
import {whiteArrowIcon, blackArrowIcon} from '../StyledIcon';
import Select, {Styles} from 'react-select';
import AsyncSelect from 'react-select/async';
import CreatableSelect from 'react-select/creatable';
import {SelectOptionType} from '../../../utils/types';
import {device} from '../../../styled/device';

export const selectWidth = '293px';
export const applySelectStyles = (select: any) => styled(select)`
  @media (max-width: 330px) {
    width: ${selectWidth};
  }

  .select__control {
    transition: 0.1s;
    border: 1px solid #a2a2b4;
  }

  & .select__value-container {
    padding: 0;
  }

  & .select__dropdown-indicator {
    padding: 0;
  }

  & .select__single-value,
  & .select__placeholder {
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-weight: 500;
    margin-left: 0;
    padding-left: 0;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }
  }

  & .select__single-value {
    color: #161643;
  }

  & .select__placeholder {
    color: #8181a3;
  }

  & .select__input input {
    margin: 0;
    padding: 0;
    font-family: Poppins, sans-serif;
    font-size: 16px;
    font-weight: 500;
    color: #161643;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }
  }

  & .select__option.select__option--is-selected {
    background-color: white;
    font-family: Poppins, sans-serif;
  }

  & .select__option.select__option--is-focused.select__option--is-selected {
    cursor: default;
    font-family: Poppins, sans-serif;
    color: #161643;
  }

  & .select__option.select__option--is-focused {
    cursor: pointer;
    color: #385cf8;
  }

  & .select__menu {
    font-family: Poppins, sans-serif;
    font-size: 16px;
    font-weight: 500;
    width: ${selectWidth};
    height: auto;
    min-height: 75px;
    max-height: 322px;
    box-shadow: 0 30px 30px #2148ff1a;
    border-radius: 0 0 8px 8px;
    z-index: 4;
    margin-top: 0;

    @media (max-width: ${device.tablet}) {
      font-size: 20px !important;
    }
  }

  & .select__menu-notice {
    color: #161643;
    text-align: left;
    margin-top: 10px;
    font-size: 16px;
  }

  & .select__menu-list {
    padding: 17px 27px 19px 16px;
    box-shadow: 0 30px 30px #2148ff1a;
    width: ${selectWidth};
    height: auto;
    min-height: 75px;
    max-height: 322px;
    border-radius: 0 0 8px 8px;
  }

  & .select__option {
    text-align: left;
    color: #161643;
    padding: 18px 0 19px 16px;
    box-sizing: border-box;
    background-color: white;
    border-bottom: 1px solid #f2f4f8;

    &:active {
      background-color: white;
    }
  }

  & .select__option:last-child {
    border-color: transparent;
  }

  @media (max-width: ${device.tablet}) {
    min-width: 327px;
  }

  @media (max-width: ${device.mobileS}) {
    min-width: 293px;
  }
`;

export const styles: Styles<SelectOptionType, boolean> = {
  input: base => ({
    ...base,
    width: 1,
    margin: 0,
    padding: 0,
    fontFamily: 'Poppins, sans-serif',
    fontSize: 16,
    color: '#161643',
  }),
};

export const ReactSelect = applySelectStyles(Select);
export const AsyncReactSelect = applySelectStyles(AsyncSelect);
export const CreatableReactSelect = applySelectStyles(CreatableSelect);

type WrapperProps = {
  disabled?: boolean;
  invalid?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;
  box-sizing: border-box;
  display: grid;
  grid-template-rows: auto 50px auto;
  cursor: pointer;
  width: 100%;
  margin-bottom: 15px;

  & .select__control {
    grid-row: 2 / 3;
    min-height: 20px;
    cursor: pointer;
    background-color: white;
    box-sizing: border-box;
    box-shadow: none;
    border-radius: 7px;
    transition: background-color 0.5s ease-in-out, border-color 0.05s ease-in-out;
    border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};

    &,
    &:hover {
      border: 1px solid ${props => (props.invalid ? '#FF2467' : '#a2a2b4')};
    }
  }

  & .select__value-container {
    padding: 0 16px;
  }

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;
    `};
`;

export const Label = styled.label`
  grid-row: 1 / 2;
  font-family: 'Poppins', sans-serif;
  text-transform: uppercase;
  font-size: 12px;
  text-align: left;
  user-select: none;
  color: #777e91;
  pointer-events: none;
  /* margin-bottom: 5px; */

  @media (max-width: ${device.mobileM}) {
    font-size: 16px;
  }
`;

type DisplayIconProps = {
  shouldRotate: boolean;
};

export const DisplayIcon = styled.img.attrs<DisplayIconProps>(props => ({
  src: props.shouldRotate ? blackArrowIcon : whiteArrowIcon,
  alt: 'Toggle menu',
}))<DisplayIconProps>`
  width: 31px;
  height: 31px;
  cursor: pointer;
  pointer-events: none;
  position: relative;
  border-radius: 50%;
  right: 12px;
  border: none !important;
  user-select: none;

  ${props =>
    props.shouldRotate &&
    css`
      /* transform: rotateX(180deg); */
      /* background-color: #353945; */
    `};
`;

export const LoaderWrapper = styled.div`
  position: absolute;
  width: 16px;
  top: -27px;
  right: 7px;
`;

export const TooltipWrapper = styled.span`
  margin-left: 6px;
  display: inline-block;
  position: relative;
  pointer-events: auto;
`;

export const Error = styled(ErrorMessage)`
  grid-row: 3 / 4;
`;
